// Hero.jsx
import React, { useEffect, useState } from "react";

const Hero = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 200);
  }, []);

  return (
    <section style={styles.hero}>
      <div style={styles.overlay}>
        <div
          style={{
            ...styles.content,
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(40px)",
          }}
        >
          <h1 style={styles.heading}>
            Decode the Future of <br />
            <span style={styles.highlight}>Blockchain</span>
          </h1>

          <p style={styles.subtext}>
            Deep insights, market trends & real-world crypto strategies —
            all in one place.
          </p>

          <div style={styles.buttonGroup}>
            <button style={styles.primaryBtn}>Explore Blogs</button>
            <button style={styles.secondaryBtn}>Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    height: "75vh",
    backgroundImage:
      "url('https://images.unsplash.com/photo-1639322537228-f710d846310a')", // 🔥 new bg
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  overlay: {
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(135deg, rgba(0,0,0,0.7), rgba(20,20,40,0.8))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  content: {
    textAlign: "center",
    color: "#fff",
    maxWidth: "700px",
    padding: "20px",
    transition: "all 0.8s ease",
  },

  heading: {
    fontSize: "48px",
    fontWeight: "800",
    lineHeight: "1.3",
    marginBottom: "20px",
  },

  highlight: {
    color: "#00f7ff",
  },

  subtext: {
    fontSize: "18px",
    marginBottom: "30px",
    color: "#ccc",
  },

  buttonGroup: {
    display: "flex",
    gap: "15px",
    justifyContent: "center",
    flexWrap: "wrap",
  },

  primaryBtn: {
    padding: "12px 28px",
    background: "linear-gradient(90deg, #ff4da6, #ff0080)",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.3s",
  },

  secondaryBtn: {
    padding: "12px 28px",
    background: "transparent",
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "30px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default Hero;